"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var BGETIncomeInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.bget) === null || _b === void 0 ? void 0 : _b.income, label: trans('project:slhh::labels.income') },
            react_1.default.createElement(__1.Select, { options: {
                    receipt_council_tax: 'In receipt of Council Tax Benefits (eligible in terms of income) - assess high energy costs and/or vulnerability',
                    no_receipt_council_tax: 'NOT in receipt of Council Tax Benefits - Assess income',
                }, name: "project.bget.income" })),
        react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.bget) === null || _d === void 0 ? void 0 : _d.income_client_below, label: trans('project:slhh::labels.income-client-below') },
            react_1.default.createElement(__1.Select, { options: {
                    single_no_children: 'Single person, no children',
                    couple_no_children: 'Couple, no children',
                    single_child_04: 'Single Person, child age 0 - 4',
                    single_primary_child: 'Single Person, child primary school age',
                    single_secondary_child: 'Single Person, child secondary school age',
                    couple_child_04: 'Couple, child age 0 - 4',
                    couple_primary_child: 'Couple, child primary school age',
                    couple_secondary_child: 'Couple, child secondary school age',
                }, name: "project.bget.income_client_below" }))));
};
exports.default = BGETIncomeInput;
//# sourceMappingURL=BGETIncomeInput.js.map